import {
  Button,
  Drawer,
  Label,
  Loading,
  Radio,
  Select,
  Title,
} from "@components";
import { Add } from "shared/components/Add";

import styles from "@styles/home-configurations.module.scss";

import { If } from "shared/components/control-statements";
import { useEffect, useMemo, useRef, useState } from "react";
import BannersConfig from "shared/containers/homeConfigurations/BannersConfig";
import CouponsConfig from "shared/containers/homeConfigurations/CouponsConfig";
import ProductsConfig from "shared/containers/homeConfigurations/ProductsConfig";
import BrandsConfig from "shared/containers/homeConfigurations/BrandsConfig";
import { UserStorage } from "shared/tools/UserStorage";

import { v4 as uuid } from "uuid";

import classNames from "classnames/bind";
import SectionComponent from "shared/containers/homeConfigurations/SectionComponent";
import BannersAdd from "shared/containers/homeConfigurations/BannersAdd";
import CouponsAdd from "shared/containers/homeConfigurations/CouponsAdd";
import ProductsAdd from "shared/containers/homeConfigurations/ProductsAdd";
import Preview from "shared/containers/homeConfigurations/Preview";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import { StandaloneCouponsAPI } from "providers/StandaloneCouponsAPI";
import { CatalogAPI } from "providers/CatalogAPI";
import { Catalog } from "shared/utils/Catalog";
import { OlgaEnvironmentsAPI } from "providers/OlgaEnvironmentsAPI";
const css = classNames.bind(styles);

const SECTION_STEPS = [
  {
    key: "BANNERS",
    name: "Banners",
    icon: <i className="fal fa-image" />,
  },
  {
    key: "COUPONS",
    name: "Cupons",
    icon: <i className="fal fa-ticket-alt" />,
  },
  {
    key: "PRODUCTS",
    name: "Produtos",
    icon: <i className="fal fa-pot-food" />,
  },
  {
    key: "BRANDS",
    name: "Marcas",
    icon: <i className="fal fa-store" />,
  },
];

const SECTION_CONFIG = {
  BANNERS: {
    title: "Adicionar banner",
  },
  COUPONS: {
    title: "Adicionar cupom",
  },
  PRODUCTS: {
    title: "Adicionar produto",
  },
  BRANDS: {
    title: "Adicionar marcas",
  },
};

const SECTION_CONFIG_COMPONENTS = {
  BANNERS: BannersConfig,
  COUPONS: CouponsConfig,
  PRODUCTS: ProductsConfig,
  BRANDS: BrandsConfig,
};

const SECTION_ADD_ITEMS_COMPONENTS = {
  BANNERS: BannersAdd,
  COUPONS: CouponsAdd,
  PRODUCTS: ProductsAdd,
};

export default function HomeConfigurations() {
  const [sectionVisible, setSectionVisible] = useState(false);
  const [sectionAddItemsVisible, setSectionAddItemsVisible] = useState(false);
  const [selectedSection, setSelectedSection] = useState(null);
  const [selectedSectionToEdit, setSelectedSectionToEdit] = useState(null);
  const [currentConfigSection, setCurrentConfigSection] = useState(null);
  const [selectedItemToEdit, setSelectedItemToEdit] = useState(null);
  const [dropdown, setDropdown] = useState(null);
  const [sorting, setSorting] = useState(false);
  const [sortingItems, setSortingItems] = useState(false);
  const [isHolding, setIsHolding] = useState(false);

  const [tempSections, setTempSections] = useState([]);
  const [sections, setSections] = useState([]);

  const [loading, setLoading] = useState(true);
  const [publishing, setPublishing] = useState(false);

  const [brands, setBrands] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [collapsedSection, setCollapsedSection] = useState({});
  const [brandId, setBrandId] = useState(null);

  const sectionsRef = useRef(null);

  const onLoad = async (brandId) => {
    setLoading(true);
    const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();
    const environmentId = brandId || holdingId;
    const sectionsResponse =
      await EnvironmentsAPI.getAppSections(environmentId);
    const sections = sectionsResponse.getData([]);
    sectionsRef.current = sections.length ? sections : null;

    console.log(environmentId, sectionsResponse)

    const holdingBrandsResponse = await EnvironmentsAPI.getUnits(holdingId);
    const brands = holdingBrandsResponse.getData({})?.brands || [];

    if (holdingBrandsResponse?.brands > 0) setIsHolding(true);

    setBrands(
      brands.map((brand) => ({
        ...brand,
        logo: buildAssetsUrl(brand.avatarUrl),
      })),
    );

    const couponsResponse = await StandaloneCouponsAPI.getAllStandaloneCoupons({
      grantType: "SYSTEM",
      status: "ACTIVATED",
    });
    const standaloneCoupons = couponsResponse.getData({ items: [] }).items;
    const publicStandaloneCoupons = standaloneCoupons.filter(
      (coupon) => !!coupon.public,
    );

    setCoupons(publicStandaloneCoupons);

    if (sections && sections.length > 0) {
      let newSections = sections.map((section) => {
        if (section.type === "COUPONS")
          return {
            ...section,
            items: (section.items ?? [])
              .filter((item) =>
                publicStandaloneCoupons.some((coupon) => coupon.id === item.id),
              )
              .map((item) => ({
                ...item,
                id: item.id ?? uuid(),
              })),
          };
        if (section.type !== "PRODUCTS") return section;

        return {
          ...section,
          items: (section.items ?? []).map((item) => ({
            ...item,
            id: item.id ?? uuid(),
          })),
        };
      });

      setSections(newSections);
      setTempSections(JSON.stringify(newSections));
    } else {
      setSections([]);
      setTempSections([]);
    }

    setLoading(false);
  };

  const buildAssetsUrl = (url) => {
    if (!url) return null;

    if (url.startsWith("http")) {
      return url;
    }

    return `${process.env.REACT_APP_ASSETS_URL}/${url}`;
  };

  const updateSections = async () => {
    setPublishing(true);

    const environmentId =
      brandId || (await EnvironmentStorage.getEnvironmentHoldingId());
    const response = await EnvironmentsAPI.upsertAppSections(
      environmentId,
      sections,
    );

    if (response.getErrors([]).length > 0) {
      alert({ text: response.getErrors()[0], buttonText: "Ok" });
      setPublishing(false);
      return false;
    } else {
      setTempSections(JSON.stringify(sections));
      setPublishing(false);
      alert({ text: "Alterações publicadas com sucesso!" });
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  useEffect(() => {
    if (sectionVisible && !selectedSectionToEdit) {
      setSelectedSection(null);
      setCurrentConfigSection(null);
    }
  }, [sectionVisible]);

  const handleContinue = () => {
    if (selectedSection) {
      setCurrentConfigSection(selectedSection);
    }
  };

  const getTitle = () => {
    if (currentConfigSection)
      return SECTION_CONFIG[currentConfigSection]?.title;

    return "Adicionar seção";
  };

  const CurrentConfigComponent =
    SECTION_CONFIG_COMPONENTS[currentConfigSection];
  const CurrentAddItemComponent =
    SECTION_ADD_ITEMS_COMPONENTS[currentConfigSection];

  const moveSection = (index, direction) => {
    const newIndex = index + direction;

    if (newIndex < 0 || newIndex >= sections.length) return;

    const newSections = [...sections];

    const temp = newSections[index];
    newSections[index] = newSections[newIndex];
    newSections[newIndex] = temp;

    const reorderedSections = newSections.map((section, idx) => ({
      ...section,
      order: idx + 1,
    }));

    setSections(reorderedSections);
  };

  useEffect(() => {
    const loadBrands = async () => {
      const user = UserStorage.getLoggedUser();
      const unitsResponse = await EnvironmentsAPI.getAvailableUnits(
        user.environment_id,
      );
      const units = unitsResponse.getData([]);
      const brands = Object.values(
        units.reduce((a, u) => ({ ...a, [u.brand.id]: u.brand }), {}),
      );
      setBrands(brands);
    };

    loadBrands();
  }, []);

  const hasChanges =
    JSON.stringify(sections) !== tempSections || !sectionsRef.current?.length;

  const brandOptions = brands.map(({ id, name }) => ({
    value: id,
    label: name,
  }));
  const selectBrand = async (brandId) => {
    setBrandId(brandId);
    onLoad(brandId);
  };

  return (
    <>
      {loading && <Loading fullContent />}
      <Title
        title="Personalização do Início"
        backTo={{ url: "/configuracoes", name: "Configurações" }}
      >
        <If cond={!sorting && !sortingItems}>
          <If cond={brandOptions.length > 1 && UserStorage.isGodMode}>
            <Select
              design="mini"
              className="mr-10"
              value={brandId}
              options={[{ value: null, label: "Grupo" }, ...brandOptions]}
              onChange={(e) => {
                const brandId = +e.target.value || null;
                selectBrand(brandId);
              }}
            />
          </If>

          <If cond={sections.length > 1}>
            <Button
              onClick={() => {
                setSorting(true);
              }}
            >
              Ordenar seções
            </Button>
          </If>
          {hasChanges && (
            <Button
              className="ml-10"
              design="primary"
              disabled={publishing}
              loading={publishing}
              onClick={updateSections}
            >
              Publicar alterações
            </Button>
          )}
        </If>
        <If cond={sorting}>
          <Button
            design="primary"
            className="mr-10"
            onClick={() => setSorting(false)}
          >
            Salvar ordenação
          </Button>
          <Button
            onClick={() => {
              setSorting(false);
            }}
          >
            Cancelar
          </Button>
        </If>
      </Title>
      <div className={styles.homeConfigurationsContainer}>
        <div className={styles.sectionsContainer}>
          {sections
            .filter((s) =>
              sortingItems ? s.id === selectedSectionToEdit?.id : s,
            )
            .map((section, index) => {
              return (
                <div className="d-flex align-center gap-10">
                  <SectionComponent
                    key={section.id}
                    section={section}
                    collapsedSection={collapsedSection}
                    brands={brands}
                    coupons={coupons}
                    onChange={(section) => {
                      setSections((sections) =>
                        sections.map((s) =>
                          s.id === section.id ? section : s,
                        ),
                      );
                    }}
                    sorting={sorting}
                    onDrop={(section) => setDropdown(section)}
                    dropdown={dropdown}
                    onSelect={(section) => {
                      setCurrentConfigSection(section.type);
                      setSelectedSection(section.type);
                      setSelectedSectionToEdit(section);
                      setSectionVisible(true);
                    }}
                    onDelete={(section) => {
                      setSections((sections) =>
                        sections.filter((s) => s.id !== section.id),
                      );
                    }}
                    onSortItems={(section) => {
                      setSelectedSection(section.type);
                      setSelectedSectionToEdit(section);
                      setSortingItems(true);
                    }}
                    sortingItems={
                      sortingItems && section.id === selectedSectionToEdit?.id
                    }
                    onCancelSorting={() => setSortingItems(false)}
                    onAddItems={(section) => {
                      setCurrentConfigSection(section.type);
                      setSelectedSection(section.type);
                      setSelectedSectionToEdit(section);
                      setSectionAddItemsVisible(true);
                      setSelectedItemToEdit(null);
                    }}
                    onSelectItem={(section, item) => {
                      setCurrentConfigSection(section.type);
                      setSelectedSection(section.type);
                      setSelectedSectionToEdit(section);
                      setSectionAddItemsVisible(true);
                      setSelectedItemToEdit(item);
                    }}
                    onDeleteItem={(section, item) => {
                      console.log(item);
                      console.log(section);
                      setSections((sections) =>
                        sections.map((s) =>
                          s.id === section.id
                            ? {
                                ...s,
                                items: s.items.filter((i) =>
                                  section.type === "PRODUCTS"
                                    ? i.id && item.id
                                      ? i.id !== item.id
                                      : i.product?.id !== item.product?.id
                                    : i.id !== item.id,
                                ),
                              }
                            : s,
                        ),
                      );
                    }}
                  />
                  <If cond={sorting}>
                    <div className="d-flex align-center gap-10">
                      <button
                        onClick={() => moveSection(index, 1)}
                        disabled={index === sections.length - 1}
                        type="button"
                        className={styles.moveDown}
                      >
                        <i className="fas fa-chevron-down" />
                      </button>
                      <button
                        onClick={() => moveSection(index, -1)}
                        disabled={index === 0}
                        type="button"
                        className={styles.moveUp}
                      >
                        <i className="fas fa-chevron-up" />
                      </button>
                    </div>
                  </If>
                </div>
              );
            })}
          <If cond={!sorting && !sortingItems}>
            <Add
              className="flex flex-column"
              text="Adicionar seção"
              icon={<i className="fal fa-plus" />}
              onClick={() => {
                setCurrentConfigSection(null);
                setSelectedSection(null);
                setSelectedSectionToEdit(null);
                setSectionVisible(true);
              }}
            />
          </If>
        </div>

        <div className={styles.previewContainer}>
          <div className={styles.previewHeader}>
            <p className={styles.title}>Pré-visualização</p>
            <i
              className="fal fa-info-circle"
              title="Por meio desta ferramenta, você poderá ver como os cards, banners e outros elementos serão organizados na tela inicial do aplicativo, facilitando ajustes antes da publicação."
            />
          </div>
          <div className={styles.preview}>
            <img src="/assets/images/preview-home-configurations.png" alt="" />
            <div className={styles.content}>
              <Preview sections={sections} brands={brands} coupons={coupons} />
            </div>
          </div>
        </div>
      </div>

      <Drawer
        visible={sectionVisible}
        onClose={() => setSectionVisible(false)}
        withoutTransition
        direction="full-center"
        showCloseButton={false}
      >
        <div className={styles.home}>
          <div className={styles.homeHeader}>
            <div className="d-flex flex-column">
              <p className={styles.title}>{getTitle()}</p>
            </div>
            <div
              className={styles.close}
              onClick={() => setSectionVisible(false)}
            >
              <i className="fas fa-times" />
            </div>
          </div>

          <If cond={!currentConfigSection}>
            <div className={styles.sectionContainer}>
              <p className={styles.title}>Defina o tipo da seção</p>
              <div className={styles.options}>
                {SECTION_STEPS.filter((option) =>
                  isHolding ? option.key !== "BRANDS" : option,
                ).map((option) => (
                  <div
                    className={css({
                      option: true,
                      selected: selectedSection === option.key,
                    })}
                    key={option.key}
                    onClick={() => setSelectedSection(option.key)}
                  >
                    <If
                      cond={!selectedSection || selectedSection !== option.key}
                    >
                      <div className={styles.icon}>{option.icon}</div>
                    </If>
                    <If cond={selectedSection === option.key}>
                      <div className={styles.radio}>
                        <Radio checked value={true} readOnly />
                      </div>
                    </If>
                    <p>{option.name}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className={styles.footer}>
              <Button
                design="primary"
                onClick={handleContinue}
                disabled={!selectedSection}
              >
                Próximo
              </Button>
            </div>
          </If>

          {CurrentConfigComponent && (
            <CurrentConfigComponent
              data={selectedSectionToEdit}
              brands={brands}
              onClose={() => setCurrentConfigSection(null)}
              onFinish={() => setSectionVisible(false)}
              onSave={(data) => {
                setSections((prev) => {
                  const exists = prev.find(
                    (item) => item.id === selectedSectionToEdit?.id,
                  );

                  const id = uuid();

                  if (exists) {
                    return prev.map((item) =>
                      item.id === selectedSectionToEdit?.id
                        ? {
                            ...item,
                            ...data,
                            order: item.order,
                            updatedBy: UserStorage.getLoggedUser()?.id || null,
                            updatedAt: new Date().toISOString(),
                          }
                        : item,
                    );
                  } else setCollapsedSection(id);

                  return [
                    ...prev,
                    {
                      ...data,
                      active: data?.type === "BRANDS",
                      id,
                      order: prev.length + 1,
                      updatedBy: UserStorage.getLoggedUser()?.id || null,
                      createdAt: new Date().toISOString(),
                      updatedAt: new Date().toISOString(),
                    },
                  ];
                });
              }}
            />
          )}
        </div>
      </Drawer>
      <Drawer
        visible={sectionAddItemsVisible}
        onClose={() => {
          setSectionAddItemsVisible(false);
          setSelectedItemToEdit(null);
        }}
        withoutTransition
        direction="full-center"
        showCloseButton={false}
      >
        <div className={styles.home} id="section-add">
          {CurrentAddItemComponent && (
            <CurrentAddItemComponent
              section={selectedSectionToEdit}
              item={selectedItemToEdit}
              items={selectedSectionToEdit?.items}
              coupons={coupons}
              onClose={() => {
                setSectionAddItemsVisible(false);
                setSelectedItemToEdit(null);
              }}
              onFinish={() => {
                setSectionAddItemsVisible(false);
                setSelectedItemToEdit(null);
              }}
              onDeleteItem={(item) => {
                setSections((prev) => {
                  return prev.map((section) =>
                    section.id === selectedSectionToEdit?.id
                      ? {
                          ...section,
                          items: (section.items ?? []).filter((i) =>
                            selectedSectionToEdit.type === "PRODUCTS"
                              ? item.id && i.id
                                ? item.id !== i.id
                                : item.product?.id !== i.product?.id
                              : item.id !== i.id,
                          ),
                          updatedBy: UserStorage.getLoggedUser()?.id || null,
                          updatedAt: new Date().toISOString(),
                          active:
                            (section.items ?? []).filter(
                              (i) => i.id !== item.id,
                            ).length > 0,
                        }
                      : section,
                  );
                });
                setSectionAddItemsVisible(false);
                setSelectedItemToEdit(null);
              }}
              onSave={(data) => {
                if (!selectedSectionToEdit) {
                  return;
                }

                setSections((prev) =>
                  prev.map((section) =>
                    section.id === selectedSectionToEdit.id
                      ? {
                          ...section,
                          items: selectedItemToEdit
                            ? (section.items ?? []).map((item) => {
                                const sameId =
                                  selectedSectionToEdit.type === "PRODUCTS"
                                    ? selectedItemToEdit.id && item.id
                                      ? selectedItemToEdit.id === item.id
                                      : item.product?.id ===
                                        selectedItemToEdit.product?.id
                                    : item.id === selectedItemToEdit.id;

                                return sameId
                                  ? { ...item, ...data }
                                  : { ...item, id: item?.id || uuid() };
                              })
                            : [
                                ...(section?.items ?? []),
                                {
                                  id: uuid(),
                                  order: section?.items?.length
                                    ? (section.items ?? []).length + 1
                                    : 1,
                                  ...data,
                                },
                              ],
                          updatedBy: UserStorage.getLoggedUser()?.id || null,
                          updatedAt: new Date().toISOString(),
                          active: !!data,
                        }
                      : section,
                  ),
                );
                setSelectedItemToEdit(null);
              }}
              onSelect={(data) => {
                if (!selectedSectionToEdit) return;

                setSections((prev) => {
                  return prev.map((item) =>
                    item.id === selectedSectionToEdit?.id
                      ? {
                          ...item,
                          items: [...data],
                          updatedBy: UserStorage.getLoggedUser()?.id || null,
                          updatedAt: new Date().toISOString(),
                          active: data.length > 0,
                        }
                      : item,
                  );
                });
                setSectionAddItemsVisible(false);
              }}
            />
          )}
        </div>
      </Drawer>
    </>
  );
}
